<template>
  <section class="sp__transition">
    <div
      v-if="displayEnhancedContactExperience"
      class="sp__transition__enhancedContact"
    >
      <ScFriendlyHero
        :heading="translations.contactSupportHeading"
        :subheading="translations.contactSupportIntroText"
      >
        <ProductSearch
          class="sp__transition__product-search"
          :custom-props="{
            focus: focus,
            hideProductIdentificationHelpLinks: displayAdditionalContactInfo
          }"
        >
          <template
            v-if="displayAdditionalContactInfo"
            #productIdentificationHelpLink="{ slotProps }"
          >
            <ul class="sp__search__tooltip__link">
              <li>
                <a
                  href="#"
                  @click.prevent="showHelpLinkDetails = !showHelpLinkDetails; onHelpLinkClick({
                    event_category: 'Support Landing', event_action: 'How do I identify my product information',
                    event_label: `Internal Link`
                  })"
                >{{ translations.contactSupportProductSearchMessageLabel }}</a>
              </li>
            </ul>
            <p
              v-show="showHelpLinkDetails"
              class="sp__search__tooltip__description"
            >
              {{ slotProps.translations.productSearchTransitionInformationText }}
              <a
                target="_blank"
                :href="translations.contactSupportFaqLink"
                @click.prevent="onHelpLinkClick({
                  event_category: 'Support Landing', event_action: 'More about identifying my product information',
                  event_label: `Internal Link`, link: translations.contactSupportFaqLink
                })"
              >{{ translations.contactSupportFaqLinkText }}</a>
              <span v-html="translations.contactSupportProductSearchMessageText" />
            </p>
          </template>
        </ProductSearch>
      </ScFriendlyHero>
      <div class="sp__transition__enhancedContact__content-container">
        <h2 class="sp__transition__additional-info--heading">
          {{ translations.additionalContactHeading }}
        </h2>
        <ScIconNavBar>
          <ScIconNavBarItem
            v-for="navItem in getIconNavBarItems"
            v-bind="navItem"
            :key="navItem.ctaText"
          />
        </ScIconNavBar>
        <div
          class="sp__transition__enhancedContact__content-container--feedback"
          @click="onAdditionalInfoLinkClick"
          v-html="translations.submitFeedback"
        />
        <div
          class="sp__transition__additional-info__cta"
          @click="onAdditionalInfoLinkClick"
          v-html="translations.supportCenterCta"
        />
      </div>
    </div>
    <div v-else>
      <template
        v-for="(child, index) in children"
        :key="index"
      >
        <component
          :is="child.component"
          :custom-props="child.customProps"
          :children="child.children"
        />
      </template>

      <div class="sp__transition__content">
        <h1 class="sp__transition__heading">
          <template v-if="focus == 'manuals'">
            {{ translations.manualsHeading }}
          </template>
          <template v-else-if="focus == 'software'">
            {{ translations.softwareHeading }}
          </template>
          <template v-else-if="focus == 'videos'">
            {{ translations.videosHeading }}
          </template>
          <template v-else-if="focus == 'topics'">
            {{ translations.contactSupportHeading }}
          </template>
        </h1>

        <div class="sp__transition__description">
          <p v-if="focus == 'manuals'">
            {{ translations.manualsIntroText }}
          </p>
          <p v-else-if="focus == 'software'">
            {{ translations.softwareIntroText }}
          </p>
          <p v-else-if="focus == 'videos'">
            {{ translations.videosIntroText }}
          </p>
        </div>

        <ProductSearch
          class="sp__transition__product-search"
          :custom-props="{
            focus: focus,
            hideProductIdentificationHelpLinks: displayAdditionalContactInfo
          }"
        >
          <template
            v-if="displayAdditionalContactInfo"
            #productIdentificationHelpLink="{ slotProps }"
          >
            <ul class="sp__search__tooltip__link">
              <li>
                <a
                  href="#"
                  @click.prevent="showHelpLinkDetails = !showHelpLinkDetails; onHelpLinkClick({
                    event_category: 'Support Landing', event_action: 'How do I identify my product information',
                    event_label: `Internal Link`
                  })"
                >{{ translations.contactSupportProductSearchMessageLabel }}</a>
              </li>
            </ul>
            <p
              v-show="showHelpLinkDetails"
              class="sp__search__tooltip__description"
            >
              {{ slotProps.translations.productSearchTransitionInformationText }}
              <a
                target="_blank"
                :href="translations.contactSupportFaqLink"
                @click.prevent="showHelpLinkDetails = !showHelpLinkDetails; onHelpLinkClick({
                  event_category: 'Support Landing', event_action: 'More about identifying my product information',
                  event_label: `Internal Link`, link: translations.contactSupportFaqLink
                })"
              >{{ translations.contactSupportFaqLinkText }}</a>
              <span v-html="translations.contactSupportProductSearchMessageText" />
            </p>
          </template>
        </ProductSearch>

        <div
          v-if="focus == 'manuals'"
          class="sp__transition__additional-help"
        >
          {{ translations.manualsAlternateFlowText }}
          <a
            :href="translations.manualsAlternateFlowLink"
          >{{ translations.manualsAlternateFlowLinkText }}</a>

          <div class="sp__transition__additional-help--systems">
            <div
              v-if="aviationEnabled"
              v-html="translations.manualsSystemsAviation"
            />
            <div
              v-if="marineEnabled"
              v-html="translations.manualsSystemsMarine"
            />
          </div>
        </div>

        <div
          v-if="displayAdditionalContactInfo"
          class="sp__transition__additional-info"
        >
          <div>
            <div
              class="sp__transition__additional-info__contact-methods"
              @click="onAdditionalInfoLinkClick"
              v-html="translations.contactMethods"
            />
            <ul
              v-if="translations.noProductFlowPrompt"
              class="sp__transition__additional-info__manual-action-links"
            >
              <li>
                <a
                  href="#"
                  @click.prevent="onNoProductFlowClick"
                >{{ translations.noProductFlowPrompt }}</a>
              </li>
            </ul>
          </div>

          <div
            @click="onAdditionalInfoLinkClick"
            v-html="translations.submitFeedback"
          />
          <div
            class="sp__transition__additional-info__cta"
            @click="onAdditionalInfoLinkClick"
            v-html="translations.supportCenterCta"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script src="./transition.mjs"></script>
